import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import ConfigUrl from "../config"

// Dashboard
import Welcome from "pages/Dashboard/Welcome"
import Whyus from "pages/Dashboard/Whyus"
import CaseStudy from "pages/Dashboard/Services"
import CasestudyDetail from "pages/Dashboard/ServiceDetail"

const authProtectedRoutes = [
  { path: `${ConfigUrl.appurl}welcome`, component: <Welcome /> },
  { path: `${ConfigUrl.appurl}whyus`, component: <Whyus /> },
  { path: `${ConfigUrl.appurl}casestudy/:type`, component: <CaseStudy /> },
  { path: `${ConfigUrl.appurl}casestudydetail/:id`, component: <CasestudyDetail /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${ConfigUrl.appurl}`,
    exact: true,
    component: <Navigate to={`${ConfigUrl.appurl}`} />,
  },
]

const publicRoutes = [
  { path: `${ConfigUrl.appurl}`, component: <Login /> },
]

export { authProtectedRoutes, publicRoutes }
